var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 54V51C54 50.4477 53.5523 50 53 50H11C10.4477 50 10 50.4477 10 51V54C10 54.5523 10.4477 55 11 55H53C53.5523 55 54 54.5523 54 54Z",
    fill: "#F64E29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 43V40C54 39.4477 53.5523 39 53 39H11C10.4477 39 10 39.4477 10 40V43C10 43.5523 10.4477 44 11 44H53C53.5523 44 54 43.5523 54 43Z",
    fill: "#F64E29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 32V29C54 28.4477 53.5523 28 53 28H11C10.4477 28 10 28.4477 10 29V32C10 32.5523 10.4477 33 11 33H53C53.5523 33 54 32.5523 54 32Z",
    fill: "#F64E29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 60V24C12 21.7909 10.2091 20 8 20C5.79086 20 4 21.7909 4 24V60C4 61.1046 4.89543 62 6 62H10C11.1046 62 12 61.1046 12 60Z",
    fill: "#F64E29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60V24C60 21.7909 58.2091 20 56 20C53.7909 20 52 21.7909 52 24V60C52 61.1046 52.8954 62 54 62H58C59.1046 62 60 61.1046 60 60Z",
    fill: "#F64E29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20C26.6172 18.7834 29.1513 18 32 18C34.8487 18 37.3828 18.7834 39 20",
    stroke: "#FBB8A9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.608 14.5C41.334 11.8163 36.9631 10 31.9444 10C26.848 10 22.4196 11.873 20.1766 14.6253",
    stroke: "#FBB8A9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C17.5642 5.32836 24.2081 2 32 2C39.7919 2 46.4358 5.32836 49 10",
    stroke: "#FBB8A9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofence);
export default __webpack_public_path__ + "static/media/Geofence.f16665d59145f01f56c8426b74ae2c0c.svg";
export { ForwardRef as ReactComponent };